module.exports = __webpack_public_path__ + "media/images/temp/icon-5-7e2bb04af2435f33c7a36128b143b93c.png";